export default __webpack_public_path__ + "static/media/react-native-logo-884x1024.c60bc3bc.png";